module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes por aprobar")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.modalEditar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalEditar
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Solicitud de " + _vm._s(_vm.solicitud.nombreEmpleado))])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "fechas"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitud.desde),
      expression: "solicitud.desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.solicitud.desde)
    },
    on: {
      "blur": _vm.calcRetorno,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitud, "desde", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitud.hasta),
      expression: "solicitud.hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.solicitud.hasta)
    },
    on: {
      "blur": _vm.calcRetorno,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitud, "hasta", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Retorno")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitud.retorno),
      expression: "solicitud.retorno"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.solicitud.retorno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitud, "retorno", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control mt-5 email text-align-center"
  }, [_c('label', [_vm._v("Cuenta con  "), _c('strong', [_vm._v(_vm._s(_vm.diasDisponiblesCambiosSolicitud))]), _vm._v("  días disponibles")])])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardarEditarFechas
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.closeModalEditar
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarConfirmacionAprobar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isApproving) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isApproving) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return _c('tr', {
      key: index + '-tabla',
      staticClass: "row-table",
      class: {
        'row-info': o.esDeDelegacion
      }
    }, [_c('td', [_c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Solicitud Delegada'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.desde))]), (o.hasta !== o.desde) ? [_c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.hasta))])] : _vm._e()], 2), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Retorno:")]), _c('span', [_vm._v(_vm._s(o.retorno))]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.retorno) + " ")]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])]), _c('td', [(!o.esSolicitudPasada) ? [(o.codigoEmpleadoReemplazante) ? [_c('span', [_vm._v(_vm._s(o.nombreEmpleadoReemplazante))]), _c('div', {
      staticClass: "icon quitar"
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          o.codigoEmpleadoReemplazante = null
        }
      }
    })])] : _c('div', {
      staticClass: "pop-over-container"
    }, [(_vm.isLoadingReemplazante && index === _vm.trIndex) ? _c('loading') : _c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleadoReemplazante),
        expression: "o.codigoEmpleadoReemplazante"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleadoReemplazante)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleadoReemplazante", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleadoReemplazante
      },
      on: {
        "selected": function($event) {
          return _vm.seleccionarEmpleadoParaReemplazo(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)] : _vm._e(), (o.estado === 2 && !o.esSolicitudPasada) ? _c('div', {
      staticClass: "contenedor-acciones show-break-2"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_vm._m(1, true), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_vm._m(2, true), _c('span', [_vm._v("Rechazar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.abrirModalEditar(o)
        }
      }
    }, [_vm._m(3, true), _c('span', [_vm._v("Editar fechas")])])]) : _vm._e(), (o.esSolicitudPasada) ? _c('span', {
      staticClass: "has-text-danger show-break-2"
    }, [_vm._v("Solicitud no aprobada oportunamente, solicitar a RRHH que lo apruebe")]) : _vm._e()], 2), _c('td', {
      staticClass: "hide-break-2"
    }, [(o.estado === 2 && !o.esSolicitudPasada) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_vm._m(4, true), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_vm._m(5, true), _c('span', [_vm._v("Rechazar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.abrirModalEditar(o)
        }
      }
    }, [_vm._m(6, true), _c('span', [_vm._v("Editar fechas")])])]) : _vm._e(), (o.esSolicitudPasada) ? _c('span', {
      staticClass: "has-text-danger"
    }, [_vm._v("Solicitud no aprobada oportunamente, solicitar a RRHH que lo apruebe")]) : _vm._e()])])
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Retorno")]), _c('th', [_vm._v("Reemplazante")]), _c('th', {
    staticClass: "hide-break-2"
  }, [_vm._v("Acciones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78756d14","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Lista_Solicitud_Vacaciones_Por_Aprobar.vue
// module id = 914
// module chunks = 0